export default "__VITE_ASSET__BD33Bkks__"